import { ApartmentUserRole } from '../apartmentAdmin/data';
import { UserRoles } from './store';

export function getUserName(
  { firstName, lastName }: { firstName?: string; lastName: string },
  lastNameFirst: boolean = false
): string {
  if (lastNameFirst) {
    return `${lastName}${firstName ? ' ' : ''}${firstName ?? ''}`;
  } else {
    return `${firstName ?? ''}${firstName ? ' ' : ''}${lastName}`;
  }
}

const guestRoles: readonly (UserRoles | ApartmentUserRole)[] = ['GUEST', ApartmentUserRole.APARTMENT_GUEST] as const;
const cannotLogInRoles: readonly (UserRoles | ApartmentUserRole)[] = [
  'GUEST',
  'PMS_LOGIN_LESS',
  'LOGIN_LESS',
  ApartmentUserRole.APARTMENT_GUEST,
  ApartmentUserRole.APARTMENT_PMS_LOGIN_LESS,
  ApartmentUserRole.APARTMENT_LOGIN_LESS,
] as const;
const cannotBeChangedRoles: readonly UserRoles[] = ['GUEST', 'PMS_LOGIN_LESS'] as const;
const firstNameOptionalRoles: readonly UserRoles[] = ['GUEST', 'LOGIN_LESS'] as const;
const adminRoles: readonly UserRoles[] = ['COMPANY_ADMIN', 'SITE_ADMIN', 'SITE_ADMIN_PAYMENT'] as const;
const withEnforcedAaStateRoles: readonly UserRoles[] = [
  ...adminRoles,
  'GUEST',
  'LOGIN_LESS',
  'PMS_LOGIN_LESS',
] as const;
const cannotBeDeviceOwnerRoles: readonly UserRoles[] = ['LOGIN_LESS', 'GUEST', 'PMS_LOGIN_LESS'] as const;
const readOnlyExternallyManagedRoles: readonly UserRoles[] = ['PMS_LOGIN_LESS'] as const;

export const isUserGuest = (role: UserRoles | ApartmentUserRole) => guestRoles.includes(role);
export const mayRoleLogIn = (role: UserRoles | ApartmentUserRole) => !cannotLogInRoles.includes(role);
export const roleCanBeChanged = (role: UserRoles) => !cannotBeChangedRoles.includes(role);
export const isFirstNameRequired = (role: UserRoles) => !firstNameOptionalRoles.includes(role);
export const isAdmin = (role: UserRoles) => adminRoles.includes(role);
export const apartmentAdminStateDictatedByRole = (role: UserRoles) => withEnforcedAaStateRoles.includes(role);
export const canOwnDevices = (role: UserRoles) => !cannotBeDeviceOwnerRoles.includes(role);
export const isUserReadOnly = (role: UserRoles) => readOnlyExternallyManagedRoles.includes(role);
